/**
 * 通用的视窗动画观察器类
 */
class IntersectionAnimation {
  /**
   * 构造函数
   * @param {Object} options - 配置选项
   * @param {string} options.targetSelector - 目标元素的选择器
   * @param {string} options.initialClasses - 元素初始状态的类名，多个类名用空格分隔
   * @param {string} options.activeClasses - 元素进入视窗时的类名，多个类名用空格分隔
   * @param {Object} [options.observerOptions] - IntersectionObserver 的配置选项
   */
  constructor(options) {
    if (
      !options ||
      !options.targetSelector ||
      !options.initialClasses ||
      !options.activeClasses
    ) {
      console.error("缺少必要的配置参数");
      return;
    }

    const {
      targetSelector,
      initialClasses,
      activeClasses,
      observerOptions = {},
    } = options;

    this.targetSelector = targetSelector;
    this.initialClasses = initialClasses;
    this.activeClasses = activeClasses;
    this.observerOptions = observerOptions;
    this.observer = null;
  }

  /**
   * 初始化观察器
   */
  init() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const initialClassList = this.initialClasses.split(" ").filter(Boolean);
        const activeClassList = this.activeClasses.split(" ").filter(Boolean);

        if (entry.isIntersecting) {
          initialClassList.forEach((className) =>
            entry.target.classList.remove(className)
          );
          activeClassList.forEach((className) =>
            entry.target.classList.add(className)
          );
        } else {
          activeClassList.forEach((className) =>
            entry.target.classList.remove(className)
          );
          initialClassList.forEach((className) =>
            entry.target.classList.add(className)
          );
        }
      });
    }, this.observerOptions);

    // 开始观察目标元素
    const targetElements = document.querySelectorAll(this.targetSelector);
    if (targetElements && targetElements.length) {
      targetElements.forEach((item) => {
        // 先添加初始类名
        this.initialClasses
          .split(" ")
          .filter(Boolean)
          .forEach((className) => {
            item.classList.remove(className);
          });
        this.observer.observe(item);
      });
    }
  }
}

// 监听页面加载完成
window.addEventListener("DOMContentLoaded", function () {
  const config = {
    targetSelector: ".AnimationWrapper_wrapper__SftXd",
    initialClasses:
      "AnimationWrapper_opacity_0__W4ib0 AnimationWrapper_transformy_20__SU0pm",
    activeClasses:
      "AnimationWrapper_opacity_1__WrCmx AnimationWrapper_transformy_0__m_64E",
  };
  const SectionAnimation = new IntersectionAnimation(config);
  // 使用通用函数创建渐变出现动画
  SectionAnimation.init();

  if (window.Shopify.designMode) {
    document.addEventListener("shopify:section:select", (event) => {
      const animationSection = document.querySelector(
        `#shopify-section-${event.detail.sectionId}`
      );

      const animationWrappers = animationSection.querySelectorAll(
        config.targetSelector
      );
      animationWrappers.forEach((item) => {
        config.initialClasses
          .split(" ")
          .filter(Boolean)
          .forEach((className) => item.classList.remove(className));
      });
    });

    // 监听section取消选中事件
    document.addEventListener("shopify:section:deselect", (event) => {
      const animationSection = document.querySelector(
        `#shopify-section-${event.detail.sectionId}`
      );
      const animationWrappers = animationSection.querySelectorAll(
        config.targetSelector
      );
      animationWrappers.forEach((item) => {
        config.initialClasses
          .split(" ")
          .filter(Boolean)
          .forEach((className) => item.classList.remove(className));
      });
    });
  }
});

